import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import axios from "axios";
import api from "@/api";

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView,
        meta: {
            title: "Dashboard",
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/notifications",
        name: "notifications",
        meta: {
            title: "Уведомления"
        },
        component: function() {
            return import("../views/NotificationsView.vue")
        }
    },
    {
        path: "/say-thanks",
        name: "say-thanks",
        meta: {
            title: "Сказать спасибо"
        },
        component: function() {
            return import("../views/SayThanksView.vue")
        }
    },
    {
        path: "/lk",
        name: "lk",
        meta: {
            title: "Личный кабинет"
        },
        component: function() {
            return import("../views/LKView.vue")
        }
    },
    {
        path: "/shop",
        // name: 'wish-shop',
        meta: {
            title: "Магазин желаний"
        },
        component: function() {
            return import("../views/ShopView.vue")
        }
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: "Авторизация",
        },
        component: function () {
            return import("../views/LoginView.vue");
        },
    },
    {
        path: "/nomenclature/products",
        name: "products",
        meta: {
            title: "Товары",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/ProductsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/products/:project/:shop/:id",
        name: "current_products",
        meta: {
            title: "Товар",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/ProductView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/categories",
        name: "categories",
        meta: {
            title: "Категории",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/CategoriesView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/categories/:project/:shop/:id",
        name: "current_category",
        meta: {
            title: "Категория",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/CategoryView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/banners",
        name: "banners",
        meta: {
            title: "Баннеры",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/BannersView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/banners/:project/:id",
        name: "banner",
        meta: {
            title: "Баннер",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/BannerView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/banners/add-banner",
        name: "add-banner",
        meta: {
            title: "Создание баннера",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/BannerAddView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/sale-view-settings",
        name: "sale-view-settings",
        meta: {
            title: "Настройки устройств для продаж",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/ViewsSettingsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/sale-view-settings/add-view-setting",
        name: "add-sale-view-setting",
        meta: {
            title: "Добавление настроек устройства",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/ViewSettingAddView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/sale-view-settings/:project/:shop/:id",
        name: "sale-view-setting",
        meta: {
            title: "Настройка устройства для продаж",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/ViewSettingView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/nomenclature/categories/:category/:shop/:id",
    //     name: "current_category",
    //     meta: {
    //         title: "Категория",
    //         group: "products",
    //     },
    //     component: function () {
    //         return import("../views/nomenclature/CategoryView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/nomenclature/fast-sets",
        name: "fast_sets",
        meta: {
            title: "Быстрые наборы",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/FastSetsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/fast-sets/:project/:shop/:id",
        name: "current_fast_set",
        meta: {
            title: "Быстрый набор",
            group: "products",
        },
        component: function () {
            return import("../views/nomenclature/FastSetView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/nomenclature/screen-savers",
        name: "screen_savers",
        meta: {
            title: "Медиа экраны",
            group: "screen_savers",
        },
        component: function () {
            return import("../views/nomenclature/ScreenSaversView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
        {
        path: "/nomenclature/screen-savers/:id",
        name: "edit_screen_savers",
        meta: {
            title: "Медиа экраны",
            group: "screen_savers",
        },
        component: function () {
            return import("../views/nomenclature/ScreenSaversEdit.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
        {
        path: "/nomenclature/terminals",
        name: "terminals",
        meta: {
            title: "Действия",
            group: "terminals",
        },
        component: function () {
            return import("../views/nomenclature/TerminalsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/charts",
        name: "reports_charts",
        meta: {
            title: "Пульс компании",
            group: "reports",
        },
        component: function () {
            return import("../views/ChartsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/by_hours",
        name: "reports_by_hours",
        meta: {
            title: "Отчет по часам",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportByHoursView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/reports/order_helpers",
    //     name: "reports_order_helpers",
    //     meta: {
    //         title: "Отчет по подсказкам для заказов",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportOrderHelpersView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    // {
    //     path: "/reports/vacancies",
    //     name: "reports_vacancies",
    //     meta: {
    //         title: "Отчет по вакансиям",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportVacanciesView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/reports/motivation-tatar",
        name: "reports_motivation_tatar",
        meta: {
            title: "Мотивация сотрудников (Татар)",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/MotivationTatar.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/schedule/calendar",
        name: "schedule_calendar",
        meta: {
            title: "Расписание - Календарь",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/CalendarView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/schedule/calendar/week_autofill",
        name: "schedule_week_autofill",
        meta: {
            title: "Расписание - Календарь",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/ShiftAutoFillWeekView.vue");
        },
    },
    {
        path: "/schedule/shifts",
        name: "schedule_shifts",
        meta: {
            title: "Расписание - Список смен",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/ReportShiftsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/schedule/day",
        name: "schedule_day",
        meta: {
            title: "Расписание - Отчет по дням",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/DayView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/schedule/time_management",
        name: "schedule_time_management",
        meta: {
            title: "Расписание - Временные возможности",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/TimeManagement.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/schedule/time_management/:id",
        name: "schedule_time_management_employee",
        meta: {
            title: "Расписание - Временные возможности",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/TimeManagementEmployee.vue");
        },
    },
    {
        path: "/schedule/employee_positions",
        name: "employee_positions",
        meta: {
            title: "Должности",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/EmployeePositions.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/schedule/shift_planing",
        name: "schedule_shift_planing",
        meta: {
            title: "Расписание - Планирование смен",
            group: "schedule",
        },
        component: function () {
            return import("../views/schedule/ShiftPlaning.vue");
        },
    },
    {
        path: "/employees",
        name: "employees",
        meta: {
            title: "Список сотрудников",
        },
        component: function () {
            return import("../views/ЕmployeesView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/orders/products",
        name: "orders_products",
        meta: {
            title: "Внутренние заказы - Товары",
            group: "orders",
        },
        component: function () {
            return import("../views/orders/OrdersProductsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/orders/order_list",
        name: "orders_list",
        meta: {
            title: "Внутренние заказы - Заказы",
            group: "orders",
        },
        component: function () {
            return import("../views/orders/OrdersListView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/orders/orders_online/",
        name: "orders_online_list",
        meta: {
            title: "Онлайн заказы",
            group: "orders",
        },
        component: function () {
            return import("../views/orders/OnlineOrdersListView.vue");
        },
        // beforeEnter: (to, from, next) => {
        //     guard(to, from, next);
        // },
    },
    {
        path: "/tasks",
        name: "tasks",
        meta: {
            title: "Задачи",
        },
        component: function () {
            return import("../views/TasksView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/study",
        name: "reports_study",
        meta: {
            title: "Обучение",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportStudyView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/reports/game_progress",
    //     name: "reports_game_progress",
    //     meta: {
    //         title: "Собери кыстыбургер",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportGameProgressView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/reports/main",
        name: "reports_main",
        meta: {
            title: "Сводный отчет",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportMainView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/preparation",
        name: "reports_preparation",
        meta: {
            title: "Планирование заготовок",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportPreparationView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/motivation",
        name: "reports_motivation",
        meta: {
            title: "Мотивация сотрудников",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/MotivationView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/product_orders",
        name: "reports_product_orders",
        meta: {
            title: "Отчет по принятию товаров",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportProductOrdersView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/by_products",
        name: "reports_by_products",
        meta: {
            title: "Отчёт по товарам",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportByProductsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/production_analytics",
        name: "reports_production_analytics",
        meta: {
            title: "Аналитика закупок",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportProductionAnalytics.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/reports/food_workers",
    //     name: "reports_food_workers",
    //     meta: {
    //         title: "Отчёт по товарам",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportFoodWorkersView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/reports/write_off",
        name: "reports_write_off",
        meta: {
            title: "Аналитика списаний",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportWriteOffView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/motivation_cheeseria",
        name: "reports_motivation_cheeseria",
        meta: {
            title: "Мотивация Чизерия",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportMotivationCheeseria.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/sales_area",
        name: "reports_sales_area",
        meta: {
            title: "Отчёт торгового зала",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportSalesArea.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/motivation_payroll",
        name: "reports_motivation_payroll",
        meta: {
            title: "Отчет по оплатам труда",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportMotivationPayroll.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/by_days",
        name: "reports_by_days",
        meta: {
            title: "Отчет по дням",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportByDaysView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/by_hours",
        name: "reports_by_hours",
        meta: {
            title: "Отчет по часам",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportByHoursView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/reservation",
        name: "reports_reservation",
        meta: {
            title: "Отчет по бронированию",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportReservation.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/stop_lists",
        name: "reports_stop_lists",
        meta: {
            title: "Стоп листы",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportStopListsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/table_updates",
        name: "reports_table_updates",
        meta: {
            title: "Оборачиваемость столов",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportTableUpdatesView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/filling_average_check",
        name: "reports_filling_average_check",
        meta: {
            title: "Наполняемость среднего чека",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportFillingAverageCheckView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/reports/non_integrated_orders",
    //     name: "reports_non_integrated_orders",
    //     meta: {
    //         title: "Неинтегрированные заказы",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportNonIntegratedOrdersView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/reports/guest_wait_time",
        name: "reports_guest_wait_time",
        meta: {
            title: "Ожидание гостя",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportGuestWaitTimeView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/council",
        name: "reports_council",
        meta: {
            title: "Отчёт совета",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportСouncilView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/cooking",
        name: "reports_cooking",
        meta: {
            title: "Отчёт приготовления блюд",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportCookingView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/detailed_checks",
        name: "reports_detailed_checks",
        meta: {
            title: "Детальные чеки",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportDetailedChecksView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/waiter_efficiency",
        name: "reports_waiter_efficiency",
        meta: {
            title: "Эффективность официантов",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportWaiterFfficiencyView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/reports/top_products",
    //     name: "reports_top_products",
    //     meta: {
    //         title: "Отчет по ТОП блюдам",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportTopProductsView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/reports/summary_invoices",
        name: "reports_summary_invoices",
        meta: {
            title: "Сводная расходная",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportSummaryInvoices.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/reports/workload",
    //     name: "reports_workload",
    //     meta: {
    //         title: "Отчёт загруженности ресторанов",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportWorkload.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    // {
    //     path: "/reports/investments",
    //     name: "reports_investments",
    //     meta: {
    //         title: "Отчет по инвестициям",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportInvestments.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    // {
    //     path: "/reports/average_time_of_fronts",
    //     name: "reports_average_time_of_fronts",
    //     meta: {
    //         title: "Отчёт по среднему времени заказов на устройствах",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportAverageTimeOfFronts.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    // {
    //     path: "/reports/tatar_report",
    //     name: "reports_tatar_report",
    //     meta: {
    //         title: "Отчет директорам",
    //         group: "reports",
    //     },
    //     component: function () {
    //         return import("../views/reports/ReportTatarView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/reports/plan_sales",
        name: "reports_plan_sales",
        meta: {
            title: "Отчет по продажам",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportPlanSales.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/wollzy",
        name: "reports_wollzy",
        meta: {
            title: "Отчет wollzy",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportWollzy.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/counteragents",
        name: "reports_counteragents",
        meta: {
            title: "Отчет по контрагентам",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportСounteragents.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/reports/balance_sheet",
        name: "reports_balance_sheet",
        meta: {
            title: "Оборотно-сальдовая ведомость",
            group: "reports",
        },
        component: function () {
            return import("../views/reports/ReportBalanceSheet.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/marketing_promocodes",
        name: "loyalty_marketing_promocodes",
        meta: {
            title: "Промокоды",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/ReportPromocodes.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/marketing_last_orders",
        name: "loyalty_marketing_last_orders",
        meta: {
            title: "Последние заказы",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/marketingLastOrdersView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/fast_sets",
        name: "loyalty_fast_sets",
        meta: {
            title: "Отчет по апсейлам",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/ReportFastSetsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/sales/view_sales",
        name: "view_sales",
        meta: {
            title: "Продажи - Отчет по выполнению плана",
            group: "sales",
        },
        component: function () {
            return import("../views/sales/ReportPlanView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/sales/edit_sales",
        name: "edit_sales",
        meta: {
            title: "Продажи - Внесение планов",
            group: "sales",
        },
        component: function () {
            return import("../views/sales/ReportEditPlanView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/sales/view_sales_tatar",
    //     name: "view_sales_tatar",
    //     meta: {
    //         title: "Продажи - Отчет по выполнению плана Татара",
    //         group: "sales",
    //     },
    //     component: function () {
    //         return import("../views/sales/ReportPlanTatarView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/finance/dds",
        name: "finance_dds",
        meta: {
            title: "Финансы - ДДС",
            group: "finance",
        },
        component: function () {
            return import("../views/finance/ReportDDSView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/finance/foodcost",
        name: "finance_foodcost",
        meta: {
            title: "Финансы - Фудкост",
            group: "finance",
        },
        component: function () {
            return import("../views/finance/ReportFoodCost.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/profits",
        name: "profits",
        meta: {
            title: "Начисления",
        },
        component: function () {
            return import("../views/ProfitsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/media",
        name: "media",
        meta: {
            title: "Медиа",
            group: "media",
        },
        component: function () {
            return import("../views/media/MediaView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/media/:id",
        name: "currentMedia",
        meta: {
            title: "Медиа",
            group: "media",
        },
        component: function () {
            return import("../views/media/CurrentMediaView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/empty",
        name: "empty",
        meta: {
            title: "В разработке",
        },
        component: function () {
            return import("../views/EmptyView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/learning",
        name: "learning",
        meta: {
            title: "Обучение",
            group: "learning",
        },
        component: function () {
            return import("../views/learning/LearningView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/learning_progress",
        name: "learning_progress",
        meta: {
            title: "Прогресс тестов",
            group: "learning",
        },
        component: function () {
            return import("../views/learning/LearningProgressView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/learning/game",
        name: "game",
        meta: {
            title: "Рецепты",
            group: "game",
        },
        component: function () {
            return import("../views/learning/games/GameHomeView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/learning/game/questions",
        name: "game-questions",
        meta: {
            title: "Рецепты",
            group: "game",
        },
        component: function () {
            return import("../views/learning/games/GameQuestionsPage.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/poll/:id",
        name: "poll",
        meta: {
            title: "Тест",
            group: "learning",
        },
        component: function () {
            return import("../views/learning/PollView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/rfm",
        name: "loyalty_rfm",
        meta: {
            title: "RFM-анализ",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/RFMView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/dashboard",
        name: "loyalty_dashboard",
        meta: {
            title: "Лояльность - Дашборд",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/DashboardView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/segmentation",
        name: "loyalty_segmentation",
        meta: {
            title: "Лояльность - Сегментация",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/SegmentationView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/marketing_guests",
        name: "loyalty_marketing_guests",
        meta: {
            title: "Лояльность - Отчет по гостям",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/marketingGuestsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/marketing_loyalty",
        name: "loyalty_marketing_loyalty",
        meta: {
            title: "Лояльность - Отчет по лояльности",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/marketingLoyaltyView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/favourite_products",
        name: "loyalty_favourite_products",
        meta: {
            title: "Лояльность - Любимые блюда приложения",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/favouriteProductsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/certificates",
        name: "loyalty_certificates",
        meta: {
            title: "Маркетинг - Сертификаты",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/marketingCertificates/marketingCertificates.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/loyalty/certificates/:id",
        name: "current_loyalty_certificates",
        meta: {
            title: "Маркетинг - Сертификаты",
            group: "loyalty",
        },
        component: function () {
            return import("../views/loyalty/marketingCertificates/marketingCurretCertificate.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/development/projects",
    //     name: "development_projects",
    //     meta: {
    //         title: "Проекты",
    //     },
    //     component: function () {
    //         return import("../views/development/ProjectsView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    // {
    //     path: "/development/estimates",
    //     name: "development_estimates",
    //     meta: {
    //         title: "Сметы",
    //     },
    //     component: function () {
    //         return import("../views/development/EstimatesView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/shop",
        name: "shop",
        meta: {
            title: "Магазин желаний",
        },
        component: function () {
            return import("../views/BonusShopView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/invoice",
        name: "invoice",
        meta: {
            title: "Накладная",
        },
        component: function () {
            return import("../views/InvoiceView.vue");
        },
    },
    {
        path: "/feedback/nps",
        name: "feedback_nps",
        meta: {
            title: "Отзывы - показатели НПС",
            group: "feedback",
        },
        component: function () {
            return import("../views/feedback/NPSView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/feedback/hashtags",
        name: "feedback_hashtags",
        meta: {
            title: "Отзывы - Хештеги",
            group: "feedback",
        },
        component: function () {
            return import("../views/feedback/HashtagsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/feedback/all_reviews",
        name: "feedback_all_reviews",
        meta: {
            title: "Отзывы - Отзывы",
            group: "feedback",
        },
        component: function () {
            return import("../views/feedback/AllReviewsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/feedback/golos_metrics",
        name: "feedback_golos_metrics",
        meta: {
            title: "Отзывы - Метрики",
            group: "feedback",
        },
        component: function () {
            return import("../views/feedback/GolosMetrics.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    // {
    //     path: "/feedback/feedback_edit",
    //     name: "feedback_feedback_edit",
    //     meta: {
    //         title: "Отзывы - Заполнение данных",
    //         group: "feedback",
    //     },
    //     component: function () {
    //         return import("../views/feedback/FeedbackEditView.vue");
    //     },
    //     beforeEnter: (to, from, next) => {
    //         guard(to, from, next);
    //     },
    // },
    {
        path: "/users/:id",
        name: "current_user",
        meta: {
            title: "Сотрудник",
            group: "users",
        },
        component: function () {
            return import("../views/users/CurrentUserView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/documents",
        name: "documents_registry",
        meta: {
            title: "Реестр документов",
            group: "documents_registry",
        },
        component: function () {
            return import("../views/documents/DocumentsRegistry.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/documents/:id",
        name: "documents_registry_current",
        meta: {
            title: "Реестр документов",
            group: "documents_registry",
        },
        component: function () {
            return import("../views/documents/CurrentDocumentsRegistry.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/orders/corporate_orders/products",
        name: "corporate_orders_products",
        meta: {
            title: "Банкеты - Товары",
            group: "corporate_orders",
        },
        component: function () {
            return import("../views/сorporateOrders/CorporateOrdersProductsView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/orders/corporate_orders/order_list",
        name: "corporate_orders_list",
        meta: {
            title: "Банкеты - Заказы",
            group: "corporate_orders",
        },
        component: function () {
            return import("../views/сorporateOrders/CorporateOrdersListView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/orders/corporate_orders/calendar",
        name: "corporate_orders_calendar",
        meta: {
            title: "Банкеты - Календарь",
            group: "corporate_orders",
        },
        component: function () {
            return import("../views/сorporateOrders/calendarViews/BanketsCalendar.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/orders/corporate_orders/calendar/day",
        name: "corporate_orders_calendar_day",
        meta: {
            title: "Банкеты - Расписание",
            group: "corporate_orders",
        },
        component: function () {
            return import("../views/сorporateOrders/calendarViews/BanketsDayView.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/settings/shops",
        name: "settings_shops",
        meta: {
            title: "Настройки - Точки продаж",
            group: "settings",
        },
        component: function () {
            return import("../views/settings/SettingsShops.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },
    {
        path: "/chat",
        name: "chat",
        meta: {
            title: "AIdar помощник",
            group: "chat",
        },
        component: function () {
            return import("../views/AIChat.vue");
        },
        beforeEnter: (to, from, next) => {
            guard(to, from, next);
        },
    },

];

const guard = function (to, from, next) {
    const hasAccess = (value, permissions) => {
        if (!value) return false;

        if (Array.isArray(value)) {
            return value.some(v => permissions.includes(v));
        }

        return permissions.includes(value);
    };

    const isInList = (value, list) => {
        if (!value) return false;

        if (Array.isArray(value)) {
            return value.some(v => list.includes(v));
        }

        return list.includes(value);
    };

    axios
        .get(api + "projects/tcode/profile/", {
            headers: {
                Authorization: "Token " + localStorage.getItem("token"),
            },
        })
        .then((response) => {
            const permissions = response.data.permissions;

            // Страницы без проверки
            const general_pages = [
                "home",
            ];

            const access_not_required = general_pages.includes(to.name);
            const page_group = isInList(to.meta.group, general_pages);

            if (access_not_required || page_group) {
                return next();
            }

            // Проверка прав
            const permissionByName = hasAccess(to.name, permissions);
            const permissionByGroup = hasAccess(to.meta.group, permissions);

            if (permissionByName || permissionByGroup) {
                return next();
            }

            return false
            // router.replace({ path: "/" });
        })
        .catch(() => {
            localStorage.removeItem('token')
            router.replace({ path: "/login" });
        });
};

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | TCode`;
    next();
});

export default router;
